import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Load Royal Mail AddressNow in head (per https://addressnow.royalmail.com/support/guides/getting-started/)
const addressNowKey = process.env.REACT_APP_ROYAL_MAIL_ADDRESSNOW_KEY;
if (addressNowKey && addressNowKey.trim()) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `https://api.addressnow.co.uk/css/addressnow-2.20.min.css?key=${addressNowKey.trim()}`;
  document.head.appendChild(link);
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://api.addressnow.co.uk/js/addressnow-2.20.min.js?key=${addressNowKey.trim()}`;
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
};

// Screengrab Studio (internal marketing imagery tool). The env var is inlined at build
// time, so this branch and the module it imports are dropped from production bundles.
if (process.env.REACT_APP_SCREENGRAB === 'true') {
  import('./devtools/screengrab')
    .then(({ activateScreengrabMode }) => activateScreengrabMode())
    .catch(() => {})
    .finally(renderApp);
} else {
  renderApp();
}

// Register service worker for PWA
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js')
      .then((registration) => {
        registration.update();

        setInterval(() => {
          registration.update();
        }, 60000);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) {
            return;
          }

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(_error => {});
  });

  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) {
      return;
    }
    refreshing = true;
    window.location.reload();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 